import axios from 'axios'
import apiUrl from '../../../constants'
import CryptoJS from 'crypto-js'
import {Validator} from 'vee-validate'
import VueElementLoading from 'vue-element-loading'
import PageTracker from '../../../common/PageTrackerHelper'

export default{
  name:'UpdateFlyerBarcode',
  components:{CryptoJS,Validator,VueElementLoading,PageTracker},
  mixins:[PageTracker],
  data: function(){
    return {
      shippingId:'',
      flyerBarcode:'',
      isLoading:false,
      userDataKey : '',
      flyerSeries: [],
    }
  },
  async mounted(){
    this.userDataKey = window.localStorage.getItem('userUniqueKey');
    let validateUser = await this.validateJwtToken();
    var userdetailEncrypt = window.localStorage.getItem('lmaccessuserdata')
    var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), this.userDataKey);
    var plaintext = bytes.toString(CryptoJS.enc.Utf8);
    var userdetail = JSON.parse(plaintext);
    this.localuserid = userdetail.userid;
    this.localusermailid = userdetail.email;
    this.flyerSeries = (userdetail.flyerSeries && userdetail.flyerSeries.length > 0) ? userdetail.flyerSeries : ["RVPSA","RVPMA","RVPLA","RVPSB","RVPMB", "RVPUN"]
  },
  methods:{
    updateFlyerBarcode: function () {
      this.isLoading = true;
      this.$validator.validateAll().then(res => {
        const flyerbarcode = this.flyerBarcode;
        const isValidSeries = this.flyerSeries.some(series =>
          flyerbarcode.toLowerCase().startsWith(series.toLowerCase())
        );

        if ([12,13].includes(flyerbarcode.length)  && isValidSeries) {
          const input = {
            ShippingId: this.shippingId.trim(),
            Flyerbarcode: flyerbarcode,
            LastModifiedBy: this.localusermailid
          };

          axios({
            method:'POST',
            url:apiUrl.api_url + 'websupport/update/shipment/flyerbarcode',
            data:input
          }).then(result =>{
            this.isLoading = false
            if (result.data.code === 200) {
              let TrackerInfo = {
                projectname:"Last Mile",
                type:"Web",
                userid:this.localuserid,
                username:this.localusermailid,
                meta: {
                  event: "updateFlyerBarcode",
                  ShippingId: this.shippingId.trim().toString(),
                  Flyerbarcode: flyerbarcode
                }
              }
              this.PageTracker(TrackerInfo);
              this.$alertify.success(result.data.message)
            }else {
              this.$alertify.error(result.data.message)
            }
            this.reset();
          }).catch(err =>{
            this.isLoading = false
            console.log("Error Details", err);
          });
        } else if (!res) {
          this.isLoading = false;
          this.$alertify.error("Invalid Input");
        } else {
          this.isLoading = false;
          this.$alertify.error("FlyerBarcode should be correct and start with a valid series");
        }
      }).catch(err => {
        this.isLoading = false;
        console.log("Error Details", err);
      });
    },
    UpperCaseFlyerBarcode(){
      var FlyerBarcode = this.flyerBarcode.toUpperCase()
      this.flyerBarcode = FlyerBarcode
    },
    reset(){
      this.$validator.reset()
      this.shippingId = ''
      this.flyerBarcode = ''
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/components/UpdateFlyerBarcode/UpdateFlyerBarcode.component.js